<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>

<main role="main">
    <h2 id="title-cancel">
        {{ 'cancellation.title' | translate }}
    </h2>
    <section class="infoBox">
        <p id="info-cancel">{{ 'cancellation.description' | translate }}</p>
    </section>
</main>